import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import clearIcon from '../../images/clear-field-icon.png';

class Insight360ReportSearchComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchBoxState: 'hide',
      searchText: '',
      clearBtnState: 'small button hide',
      searchBtnState: 'button search-button',
      searchTextBox: 'search-box',
      searchType: 2, // Searches answer and questions
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      (this.props.activeAccountId !== nextProps.activeAccountId ||
        this.props.moduleStudy !== nextProps.moduleStudy) &&
      this.props.loginResponse
    ) {
      this.handleClear();
    }
  }

  handleSearch = () => {
    this.doSearch(this.state.searchType);
    this.setState({
      searchBoxState: 'hide',
      // searchTextBox: 'search-box is-disabled',
      searchBtnState: 'hide',
      clearBtnState: 'small button',
    });
  };

  handleSearchText = () => {
    if (this.clearBtn && this.searchBox.value === '') {
      this.clearBtn.click();
    } else {
      this.setState({ searchText: this.searchBox.value });
    }
  };

  handleKeyPress = e => {
    if (e.key === 'Enter' && this.state.searchText.length !== 0) {
      this.handleSearch();
    }
  };

  doSearch = type => {
    this.props.searchDictionaryTree(type, this.state.searchText);
  };

  handleClear = event => {
    if (event) {
      event.preventDefault();
      this.props.resetDictionaryTree();
    }
    this.searchBox.value = '';
    this.setState({
      searchBoxState: 'hide',
      searchBtnState: 'button search-button',
      clearBtnState: 'hide',
      searchTextBox: 'search-box',
      searchText: this.searchBox.value,
    });
  };

  render() {
    return (
      <div>
        <div className="search-component">
          <div className="row expanded">
            <div className="insigt360-report-search-input-box">
              <input
                type="text"
                id="right-label"
                placeholder="Search..."
                className={`${
                  this.state.searchTextBox
                } insigt360-report-search-input`}
                onChange={this.handleSearchText}
                onKeyPress={e => this.handleKeyPress(e)}
                ref={searchBox => {
                  this.searchBox = searchBox;
                }}
                autoFocus
              />
              <button
                className={`${
                  this.state.searchBtnState
                } button insigt360-report-search-input-button`}
                disabled={this.state.searchText.length === 0}
                onClick={this.handleSearch}
              >
                <i className="fa fa-search" />
              </button>
              <button
                className={`${
                  this.state.clearBtnState
                } button insigt360-report-search-input-button`}
                onClick={this.handleClear}
                ref={node => (this.clearBtn = node)}
              >
                <img title="Clear All" src={clearIcon} alt="clear" />
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Insight360ReportSearchComponent.propTypes = {
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      token: PropTypes.string,
      uid: PropTypes.number,
    }),
  }),
  activeAccountId: PropTypes.number,
  moduleStudy: PropTypes.shape({
    pn: PropTypes.number,
  }),
};

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    dictionaryTree: state.dictionary.dictionaryTree,
  };
}

function mapDispatchToProps() {
  return {};
}
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Insight360ReportSearchComponent);
